<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">

      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3 d-flex justify-content-between align-items-center">
      <CBreadcrumbRouter class="border-0 mb-0"/>
      <!-- custom section -->
      <div>
        <port-search />
      </div>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import PortSearch from '../components/port/PortSearch'

export default {
  name: 'TheHeader',
  components: {
    PortSearch,
    TheHeaderDropdownAccnt
  }
}
</script>
